module.exports = __webpack_public_path__ + "img/image-collection-sliding-overlays-lincoln.f2220e2b.png";